module.exports = __webpack_public_path__ + "static/img/rank_238.3c41d7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_238.png
// module id = ybhd
// module chunks = 1